import React from 'react';
import fa from 'locales/fa.json';
import { faNumber } from 'utils/common.util';
import { HomeType } from 'types/course.type';

type ItemsType = { count: number; text: string };
const Items: React.FC<ItemsType> = ({ count, text }) => {
  return (
    <div className="center flex-col w-[250px] my-[30px]">
      <div
        className="font-bold text-[40px] xl:text-[48px] mt-[10px] center"
        suppressHydrationWarning
      >
        {faNumber(count.toLocaleString())} +
      </div>
      <h3 className="text-[16px] xl:text-[18px] center text-gray-10">
        {fa.landing[text]}
      </h3>
    </div>
  );
};

const Info: React.FC<{ data: HomeType }> = ({ data }) => (
  <div className="center">
    <div className="w-[280px] flex-col md:flex-row relative md:w-[90vw] justify-around max-w-[1200px] rounded-[8px] center">
      <Items count={Math.floor(data.count_users / 1000) * 1000} text="infoStudent" />
      <Items count={Math.floor(data.count_workshops / 50) * 50} text="infoCourses" />
      <Items
        count={Math.floor(data.time_all_workshops / 10000) * 10000}
        text="infoTime"
      />
    </div>
  </div>
);

export default Info;
